import {useEffect} from "react";
import {useApp} from "../app.context";

function SaveButton() {
    const {exportRemoteConstants} = useApp()

    useEffect(() => {
        const handleSaveShortcut = (event: any) => {
            if ((event.metaKey || event.ctrlKey) && event.key === 's') {
                event.preventDefault();
                exportRemoteConstants(false);
            }
        };

        window.addEventListener('keydown', handleSaveShortcut);
        return () => {
            window.removeEventListener('keydown', handleSaveShortcut);
        };
    }, [exportRemoteConstants]);

    return (<></>)
}

export default SaveButton;